import { type FC } from "react";

import { Button } from "@snapchat/snap-design-system";
import { LinkIcon } from "@snapchat/snap-design-system-icons";

import { TemporaryTooltip } from "../../../../lens/components/shared";

interface DeeplinkCopyProps {
    active: boolean;
    copyDeeplinkToClipboard: () => void;
}

export const CopyDeeplink: FC<DeeplinkCopyProps> = ({ active, copyDeeplinkToClipboard }) => {
    if (!active) {
        return (
            <Button data-testid="lens-copy-deeplink-disabled" shape="circle" title="Copy Link" isDisabled={true}>
                <LinkIcon />
            </Button>
        );
    }

    return (
        <TemporaryTooltip content="Lens link copied to clipboard" callbackAction={copyDeeplinkToClipboard}>
            <Button data-testid="lens-copy-deeplink" shape="circle" title="Copy Link">
                <LinkIcon />
            </Button>
        </TemporaryTooltip>
    );
};
